import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import TC from "typecheck-extended";
import { Button, Form, Segment, Modal } from "semantic-ui-react";
import { LoanAdditionalFees } from "../../../../../../../../../../../../services/ApiLib";
import {
  AmortizedForm,
  BillToBorrowerForm,
  DisplayOnlyTableForm
} from "../Forms";

export class EditFeeModalObj extends Component {
  constructor(props) {
    super(props);
    this.saveChanges = this.saveChanges.bind(this);
    this.toggleModalVisibility = this.toggleModalVisibility.bind(this);
    this.updateValues = this.updateValues.bind(this);
    this.state = {
      feeValues: "",
      errorMsg: "",
      modalVisible: false
    };
  }

  toggleModalVisibility() {
    const { modalVisible } = this.state;
    this.setState({
      modalVisible: !modalVisible
    });
  }

  openModal() {
    const { fee } = this.props;
    this.addIntitialValsToState(fee);
    this.toggleModalVisibility();
  }

  addIntitialValsToState(fee) {
    const newState = { ...this.state.feeValues, ...fee };
    this.setState({ feeValues: { ...newState } });
  }

  resetState() {
    this.setState({ feeValues: "" });
  }

  updateValues({ name, value }) {
    let transCode = "";
    if (value === "Discount on Retained") {
      transCode = "1000";
    }
    if (value === "Servicing Asset") {
      transCode = "2000";
    }
    if (value === "Other") {
      transCode = "3000";
    }
    if (name === "amortized_reason") {
      const newState = {
        ...this.state.feeValues,
        [name]: value,
        amortization_tran_code: transCode
      };
      this.setState({ feeValues: { ...newState } });
    } else {
      const newState = { ...this.state.feeValues, [name]: value };
      this.setState({ feeValues: { ...newState } });
    }
  }

  notifyUser(errorMsg) {
    TC(errorMsg, "string");
    this.setState({ errorMsg });
  }

  updateUI() {
    const { dispatch } = this.props;
    const { feeValues } = this.state;
    dispatch({
      fee: feeValues,
      type: "LOAN_MGMT_DETAILS_UPDATE_FEE"
    });
    this.toggleModalVisibility();
  }

  saveChanges() {
    const { uuid } = this.state.feeValues;
    const body = {
      ...this.state.feeValues
    };
    // TODO: #5740 figure out error handling with `asyncFetchService`s
    //       Right now, rsp.error will never be triggered – even on errors.
    LoanAdditionalFees.update(uuid, body)
      .then(() => this.updateUI())
      .catch(() => this.notifyUser("Error: Could Not Save Fee"));
  }

  render() {
    const { fee } = this.props;
    const { errorMsg, feeValues, modalVisible } = this.state;
    return (
      <React.Fragment>
        <Button
          onClick={() => this.openModal(fee)}
          basic
          circular
          icon="edit"
          disabled={!!fee.bill_uuid}
          data-tooltip={
            fee.bill_uuid
              ? "Bill to Borrower fees cannot be edited once the Additional Fee Bill has been created."
              : null
          }
          data-inverted
        />
        <Modal
          closeIcon
          onClose={() => {
            this.toggleModalVisibility();
            this.resetState();
          }}
          open={modalVisible}
        >
          <Modal.Header>Edit Fee</Modal.Header>
          <Modal.Content image>
            <Segment padded basic>
              <Form onSubmit={() => this.saveChanges()} className="edit-form">
                <Form.Select
                  label="Fee Type"
                  selection
                  name="fee_type"
                  options={[
                    { key: "Amortized", value: "Amortized", text: "Amortized" },
                    {
                      key: "Display Only",
                      value: "Display Only",
                      text: "Display Only"
                    },
                    {
                      key: "Bill to Borrower",
                      value: "Bill to Borrower",
                      text: "Bill to Borrower"
                    }
                  ]}
                  disabled
                  value={feeValues.fee_type || ""}
                  onChange={(ev, data) => this.updateValues(data)}
                />
                {feeValues.fee_type === "Amortized" && (
                  <Form.Select
                    label="Amortization Method"
                    selection
                    name="amortization_method"
                    options={[
                      {
                        key: "Level Yield",
                        value: "Level Yield",
                        text: "Level Yield"
                      }
                    ]}
                    value={feeValues.amortization_method}
                    onChange={(ev, data) => this.updateValues(data)}
                  />
                )}
                {feeValues.fee_type === "Amortized" && (
                  <AmortizedForm
                    updateValues={this.updateValues}
                    fee={feeValues}
                    interestRate={this.props.interestRate}
                    currentBalance={this.props.currentBalance}
                  />
                )}
                {feeValues.fee_type === "Bill to Borrower" && (
                  <BillToBorrowerForm
                    updateValues={this.updateValues}
                    fee={feeValues}
                  />
                )}
                {feeValues.localeComparefee_type === "Display Only" && (
                  <DisplayOnlyTableForm
                    updateValues={this.updateValues}
                    fee={feeValues}
                  />
                )}
                <h3 style={{ color: "red" }}>{errorMsg}</h3>
                <Button type="submit" content="Save Changes" />
              </Form>
            </Segment>
          </Modal.Content>
        </Modal>
      </React.Fragment>
    );
  }
}

EditFeeModalObj.propTypes = {
  dispatch: PropTypes.func.isRequired,
  interestRate: PropTypes.string,
  currentBalance: PropTypes.string,
  fee: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    fee_type: PropTypes.string.isRequired,
    bill_uuid: PropTypes.string
  }).isRequired
};

const EditFeeModal = connect()(EditFeeModalObj);

export default EditFeeModal;
